import React from 'react';
import COLORS from '../../constants/colors';
import ProductAttributeSet from '../../components/ProductAttributeSet';
import ProductAttribute from '../../components/ProductAttribute';
import SectionTitle from '../../components/SectionTitle';
import iconsIcon from './assets/icons.png';
import illustrationsIcon from './assets/illustrations.png';
import photographyIcon from './assets/photography.png';
import desktopMobileIcon from './assets/desktop.png';

const iconsDescription = (
  <span>
    Icons are like emojis, they communicate complex functions, features, and
    emotions with shapes and colors. They make it easy for users to navigate
    your website and grasp information. You'll get the art files for these as
    well to implement wherever you want.
  </span>
);

const illustrationsDescription = (
  <span>
    Illustrations bring life and beauty to your website. By being friendly and
    easy to understand, illustrations show users that you care. Like icons,
    you'll have access to the full art files to reuse where you please.
  </span>
);

const photographyDescription = (
  <span>
    For some sites, photography plays the same role as illustrations: bringing
    vibrancy to the web experience. It shows that you're human and that your
    product is real! High resolution photos with no licensing are included for
    free.
  </span>
);

const desktopMobileDescription = (
  <span>
    Having a site that looks great on a desktop, tablet, and mobile phone is
    important for a unified web presence. It makes users happy and more likely
    to buy or come back later.
  </span>
);

function ProductImagery({ color }) {
  return (
    <div>
      <SectionTitle color={color}>
        IMAGERY&nbsp;
        <span style={{ color: COLORS.BLUE }}> &#x25CF;</span>
        <span style={{ color: COLORS.PURPLE }}> &#x25CF;</span>
      </SectionTitle>
      <ProductAttributeSet>
        <div className="row">
          <ProductAttribute
            icon={iconsIcon}
            title="ICONS"
            description={iconsDescription}
          />
          <ProductAttribute
            icon={illustrationsIcon}
            title="ILLUSTRATIONS"
            description={illustrationsDescription}
          />
        </div>
        <div className="row">
          <ProductAttribute
            icon={photographyIcon}
            title="PHOTOGRAPHY"
            description={photographyDescription}
          />
          <ProductAttribute
            icon={desktopMobileIcon}
            title="DESKTOP & MOBILE VIEWS"
            description={desktopMobileDescription}
          />
        </div>
      </ProductAttributeSet>
    </div>
  );
}

export default ProductImagery;



// WEBPACK FOOTER //
// ./src/components/ProductImagery/index.js